import { render, staticRenderFns } from "./req_view.vue?vue&type=template&id=68e80a42&"
import script from "./req_view.vue?vue&type=script&lang=js&"
export * from "./req_view.vue?vue&type=script&lang=js&"
import style0 from "./req_view.vue?vue&type=style&index=0&id=68e80a42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports